export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";